import {
  GETVOUCHERREDEEMLIST_SUCCESS,
  GETVOUCHERREDEEMLIST_FAILED,
  RESET_GETVOUCHERREDEEMLIST,
  LOADING_GETVOUCHERREDEEMLIST,
  NETWORK_ERROR_GETVOUCHERREDEEMLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetVoucherRedeemList = () => {
  return { type: RESET_GETVOUCHERREDEEMLIST };
};

const getVoucherRedeemListReq = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETVOUCHERREDEEMLIST });
  await partnerServices
    .post("getVoucherRedeemList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {

      switch (res.data.status) {
        case "success":
          dispatch(getVoucherRedeemListSuccess(res.data));
          break;
        default:
          dispatch(getVoucherRedeemListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GETVOUCHERREDEEMLIST,
        payload: err,
      });
    });
};
function getVoucherRedeemListSuccess(data) {
  return {
    type: GETVOUCHERREDEEMLIST_SUCCESS,
    payload: data,
  };
}
function getVoucherRedeemListFailed(data) {
  return {
    type: GETVOUCHERREDEEMLIST_FAILED,
    payload: data,
  };
}

export { resetGetVoucherRedeemList, getVoucherRedeemListReq };
